import { FC, useMemo } from 'react';

import { Exam } from 'store/my-registrations/types';

import { ExamsGroup, ExamsGroupProps } from './ExamsGroup';

export const ExamsGroups: FC<{ exams: Exam[] }> = ({ exams }) => {
  const examsGroups = useMemo(
    () =>
      exams.reduce((groups, exam) => {
        let existingGroup = groups.find((g) => g.registrationGroupReference === exam.registrationGroupReference);
        if (existingGroup) {
          existingGroup.exams.push(exam);
        } else {
          groups.push({
            registrationGroupReference: exam.registrationGroupReference,
            registrationGroupId: exam.registrationGroupId,
            paymentSlipNumber: exam.paymentSlipNumber,
            candidateName: exam.candidateName,
            isChild: exam.isChild,
            exams: [exam],
            countryId: exam.countryId,
            paid: exam.paid,
          });
        }
        return groups;
      }, [] as ExamsGroupProps[]) ?? [],
    [exams],
  );

  return (
    <>
      {examsGroups.map((group, i) => (
        <ExamsGroup key={i} {...group} />
      ))}
    </>
  );
};
